export const REGIONS_WITH_OVERVIEW_BLOCKS_SELECT_CONTROLLER_CONSTS = {
  allRegionsMsg: 'Все регионы',
  checkAllMsg: 'Выбрать все',
  dontShowMsg: 'Не выводить'
}
